import { get, includes, map } from 'lodash';
import { getDoctorCardProps } from '../../utils';
import {
    SCHEDULING_ROOT_KEY,
    DOCTOR_CARD_ROOT_KEY,
    PROCEDURE_ROOT_KEY,
    BOOKING_CONTAINER_ROOT_KEY,
    INITIAL_BOOKING_ROOT_KEY,
} from '../../constants';
import { BookingErrorCodes } from '../../actions/constants';
import bookingStateSelector from '../../selectors/BookingStateSelector';
import insuranceNotTakenRequirementSelector from '../../selectors/InsuranceNotTakenRequirementSelector';
import patientSelector from '../../selectors/PatientSelector';
import appointmentInfoStateSelector from './AppointmentInfoPageSelector';

const checkForRootKeys = state => {
    if (state[SCHEDULING_ROOT_KEY] === undefined) {
        throw new Error(
            'Expected the scheduling state to be available as ' +
                `state.${state[SCHEDULING_ROOT_KEY]}. ` +
                "Ensure you have added the 'SchedulingReducer' to your store's " +
                "reducers via 'combineReducers'."
        );
    }

    if (state[DOCTOR_CARD_ROOT_KEY] === undefined) {
        throw new Error(
            'Expected the doctor card state to be available as ' +
                `state.${state[DOCTOR_CARD_ROOT_KEY]}. ` +
                "Ensure you have added the 'doctorCardReducer' to your store's " +
                "reducers via 'combineReducers'."
        );
    }
};

const updateBookingStateFailureFromTimeslotError = state => {
    const combinedErrors = (state[SCHEDULING_ROOT_KEY].errors || []).concat(
        state[SCHEDULING_ROOT_KEY].bookingErrors || []
    );

    if (combinedErrors.length > 0) {
        const errorFieldNames = map(
            combinedErrors,
            invalidFieldObj => invalidFieldObj.name
        );
        return includes(errorFieldNames, 'appointment_time');
    }

    return false;
};

export const mapStateToProps = (state = {}) => {
    checkForRootKeys(state);

    const professionalName = state[DOCTOR_CARD_ROOT_KEY].professional
        ? `${state[DOCTOR_CARD_ROOT_KEY].professional.firstName} ${state[DOCTOR_CARD_ROOT_KEY].professional.lastName}`
        : 'Professional Name';

    const appointmentInfoPageState = appointmentInfoStateSelector(state);

    const stateToMap = {
        bookingState: bookingStateSelector(state),
        defaultProcedureId: get(
            state[DOCTOR_CARD_ROOT_KEY],
            'professional.defaultProcedureId'
        ),
        insuranceNotTakenRequirement: insuranceNotTakenRequirementSelector(
            state
        ),
        localInSync: state[SCHEDULING_ROOT_KEY].localInSync,
        locationTimeZoneId: state[INITIAL_BOOKING_ROOT_KEY].locationTimeZoneId,
        modalIsShowing: state[BOOKING_CONTAINER_ROOT_KEY].showModal,
        patientId: patientSelector(state).patientId,
        procedureMayNotBeCovered: get(
            state[PROCEDURE_ROOT_KEY],
            'insuranceMayNotCover',
            false
        ),
        professionalName,
        specialtyId: get(
            state[DOCTOR_CARD_ROOT_KEY],
            'professional.specialtyId'
        ),
        ...appointmentInfoPageState,
    };

    if (
        state[SCHEDULING_ROOT_KEY].bookingErrorCode ===
        BookingErrorCodes.TimeslotGoneException
    ) {
        stateToMap.showTimesGrid = true;
        stateToMap.hasAppointmentTimeError = true;
    } else if (
        state[SCHEDULING_ROOT_KEY].updateBookingStateSuccess ||
        state[SCHEDULING_ROOT_KEY].getBookingStateSuccess
    ) {
        stateToMap.showTimesGrid = false;
        stateToMap.hasAppointmentTimeError = false;
    } else if (
        !state[SCHEDULING_ROOT_KEY].updatingBookingState &&
        !state[SCHEDULING_ROOT_KEY].gettingBookingState &&
        updateBookingStateFailureFromTimeslotError(state)
    ) {
        stateToMap.showTimesGrid = true;
        stateToMap.hasAppointmentTimeError = true;
    }

    return {
        ...stateToMap,
        ...getDoctorCardProps(state),
    };
};

export default mapStateToProps;
